import { render, staticRenderFns } from "./XmRuleSettings.vue?vue&type=template&id=52063c3e&scoped=true"
import script from "./XmRuleSettings.vue?vue&type=script&lang=js"
export * from "./XmRuleSettings.vue?vue&type=script&lang=js"
import style0 from "./XmRuleSettings.vue?vue&type=style&index=0&id=52063c3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52063c3e",
  null
  
)

export default component.exports